module.exports = __webpack_public_path__ + "static/assets/51e22c71c1668188b5a3ddd9dc391ff6.svg";